import { render, staticRenderFns } from "./radio-judge-widget.vue?vue&type=template&id=dc3abcd8&scoped=true&"
import script from "./radio-judge-widget.vue?vue&type=script&lang=js&"
export * from "./radio-judge-widget.vue?vue&type=script&lang=js&"
import style0 from "./radio-judge-widget.vue?vue&type=style&index=0&id=dc3abcd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3abcd8",
  null
  
)

export default component.exports